var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JUNE_ICONS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.78,48.12l3.04,3.05H0v2.3h21.8l-3.04,3.05,1.63,1.62,5.8-5.83-5.79-5.82-1.63,1.62Zm0-16.32l3.04,3.05H0v2.3h21.8l-3.04,3.05,1.63,1.62,5.8-5.83-5.79-5.82-1.63,1.62Zm0-16.32l3.04,3.05H0v2.3h21.8l-3.04,3.05,1.63,1.62,5.8-5.83-5.79-5.82-1.63,1.62ZM50.76,0c-10.56,0-21.24,2.28-21.24,6.65v58.7c0,4.37,10.69,6.65,21.24,6.65s21.24-2.28,21.24-6.65V6.65c0-4.37-10.69-6.65-21.24-6.65Zm18.94,65.35c0,1.48-6.69,4.35-18.94,4.35s-18.94-2.88-18.94-4.35V9.84c3.71,2.28,11.36,3.46,18.94,3.46s15.23-1.18,18.94-3.46v55.51ZM50.76,11c-12.26,0-18.94-2.87-18.94-4.35s6.69-4.35,18.94-4.35,18.94,2.88,18.94,4.35-6.69,4.35-18.94,4.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.42eac382a7539aae107018571d6d9cf6.svg";
export { ForwardRef as ReactComponent };